import React, { useEffect, useState } from "react";
import { Stepper, Step, StepLabel, StepContent } from "@mui/material";
import Typography from "@mui/material/Typography";

import { LABELS } from "common/lables";

import { CUSTOMER_APIs } from "apihandlers/customer";

const ActivityBoard = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [activityData, setActitvityData] = useState([]);

  useEffect(() => {
    getActivityChart();
  }, []);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  const getActivityChart = async () => {
    try {
      const args = {};
      const res: any = await CUSTOMER_APIs.getCrmLeadActivities(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response;

        const steps = list.activities.map((item) => {
          return {
            time: item.time,
            description: item.description,
          };
        });

        setActitvityData(steps);
      }
    } catch (error) {
      console.error("GetActivityChart:", error);
    }
  };

  return (
    <div
      style={{
        border: "1px solid #ccc",

        borderRadius: 4,

        paddingLeft: 12,

        marginBottom: 20,
      }}
    >
      <h4 style={{ textAlign: "center" }}>{LABELS.ACTIVITY_BOARD}</h4>

      <div style={{ width: "100%", overflow: "auto", height: 250 }}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {activityData.map((step, index) => (
            <Step key={step.time} active={true} style={{ marginBottom: -10 }}>
              <StepLabel>{step.time}</StepLabel>

              <StepContent style={{ marginTop: "-0.5rem" }}>
                <Typography style={{ fontWeight: "500" }}>
                  {step.description}
                </Typography>
              </StepContent>

              {/* <StepContent>

              <div style={{ fontWeight: "100", paddingTop: "0.5rem" }}>

                {step.other}

              </div>

            </StepContent> */}
            </Step>
          ))}
        </Stepper>
      </div>
    </div>
  );
};

export default ActivityBoard;
